import React from "react";
import { BrowserRouter } from "react-router-dom";
import Main from "./Main";
import { Provider } from "react-redux";
import { store } from "./store";
const Fullmain = () => {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <Main />
      </Provider>
    </BrowserRouter>
  );
};

export default Fullmain;
